var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plv-product-list"},[(_vm.productSdk)?_c('product-list',{attrs:{"product-sdk":_vm.productSdk,"lang":_vm.lang},on:{"browse-product":_vm.handleBrowseProduct,"click-buy":_vm.handleClickBuy}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }